import { colors } from "../../lib/designTokens";
import React from "react";

type Props = {
  title: React.ReactNode;
  value?: string | number | null;
  tooltip?: string;
  trend?: number;
  comparison?: {
    previousValue?: string | null;
    movement: "improved" | "declined" | "flat" | "unavailable";
    implication?: string;
  };
  compact?: boolean;
};

export default function Scorecard({ title, value, tooltip, trend, comparison, compact = false }: Props) {
  const isPositive = trend !== undefined && trend > 0;
const isNegative = trend !== undefined && trend < 0;
const isUnavailable =
  value === undefined ||
  value === null ||
  value === "" ||
  value === "—";

  return (
    <div
  title={tooltip}
  style={{
    background: "#ffffff",
    padding: compact ? "12px 14px" : "16px 18px 14px",
    borderRadius: 14,
    border: `1px solid ${colors.border}`,
    boxShadow: "0 8px 22px rgba(15, 23, 42, 0.04)",
    borderTop: `3px solid ${isUnavailable ? colors.border : colors.primary}`,
    opacity: isUnavailable ? 0.78 : 1,
    minHeight: compact ? 122 : 104,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  }}
>
  {/* TITLE */}
  <div
    style={{
      fontSize: 12,
      fontWeight: 700,
      color: colors.textSecondary,
      marginBottom: compact ? 6 : 10,
      letterSpacing: "0.055em",
      textTransform: "uppercase",
      display: "flex",
      alignItems: "center",
      gap: 6,
      lineHeight: 1.25,
      minHeight: 28
    }}
  >
    <span>{title}</span>

    {tooltip && (
      <span
        style={{
          fontSize: 12,
          cursor: "pointer",
          opacity: 0.75,
          color: colors.textSecondary,
          flexShrink: 0
        }}
        title={tooltip}
      >
        ⓘ
      </span>
    )}
  </div>

  {/* VALUE */}
<div
  style={{
    flex: 1,
    display: "flex",
    alignItems: "center"
  }}
>
  <div
    style={{
      fontSize: compact ? 29 : 34,
      fontWeight: 800,
      color: isUnavailable ? colors.textSecondary : colors.textPrimary,
      lineHeight: 1,
      letterSpacing: "-0.04em",
      whiteSpace: "nowrap"
    }}
  >
    {isUnavailable ? "—" : value}
  </div>
</div>

  {/* TREND optional */}
  {!isUnavailable && trend !== undefined && (
    <div
      style={{
        marginTop: 8,
        fontSize: 12,
        fontWeight: 600,
        color: isPositive
          ? colors.success
          : isNegative
          ? "#dc2626"
          : colors.textSecondary
      }}
    >
      {isPositive && "↑ "}
      {isNegative && "↓ "}
      {Math.abs(trend)}%
    </div>
  )}
  {comparison ? <div data-testid="scorecard-comparison" style={{ marginTop: 8, color: colors.textSecondary, fontSize: 12, lineHeight: 1.35 }}>
    {comparison.movement === "unavailable" || !comparison.previousValue ? (
      <div>Previous comparison unavailable</div>
    ) : <>
      <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
        <span>Previous {comparison.previousValue}</span>
        <span data-testid="scorecard-movement" style={{ color: comparison.movement === "improved" ? colors.success : comparison.movement === "declined" ? "#dc2626" : colors.textSecondary, fontWeight: 800, textTransform: "capitalize" }}>{comparison.movement}</span>
      </div>
      {comparison.implication ? <div style={{ marginTop: 3 }}>{comparison.implication}</div> : null}
    </>}
  </div> : null}
</div>
  );
}
